<template>
  <div class="score">
    <h2 class="score__title">
      <Img
        src="/images/ranking/score/score_ttl_normal_01.png"
        alt="スコア"
        class="image-rendering-pixelated"
        :width="200"
      />
    </h2>
    <div class="score__content">
      <div class="score__content__inner">
        <p class="text-center text-base font-bold">
          <span class="text-username"
            >{{ name }}<span class="text-xs">さん</span></span
          >
        </p>
        <template v-if="page !== 'ranking'">
          <Img
            class="mt-1"
            src="/images/ranking/score/score_txt_06.svg"
            alt="今回の得点は・・・"
            :width="137"
            :height="16"
          />
        </template>
        <dl v-if="page === 'ranking'" class="mt-2 flex flex-col gap-y-4">
          <dt>
            <Img
              src="/images/ranking/score/score_txt_01.svg"
              alt="前回の得点"
            />
          </dt>
          <dd>
            <p v-if="page === 'ranking'" class="flex flex-row justify-center">
              <VNumber :string-array="scoreArray" size="medium" />
              <span
                ><Img
                  src="/images/ranking/score/score_txt_number_m_01.svg"
                  alt="点"
              /></span>
            </p>
          </dd>
        </dl>
        <p v-else class="mt-4 flex flex-row justify-center">
          <VNumber
            :string-array="scoreArray"
            size="large"
            :is-animated="true"
          />
          <span
            ><Img
              src="/images/ranking/score/score_txt_number_l_02.svg"
              alt="点"
          /></span>
        </p>
        <p v-if="isBestScore" class="mt-2 flex justify-center">
          <Img src="/images/ranking/score/score_txt_04.svg" alt="自己新記録" />
        </p>
        <dl class="mt-4 flex flex-col gap-y-2">
          <dt>
            <Img
              v-if="page === 'ranking'"
              src="/images/ranking/score/score_txt_02.svg"
              alt="前回の順位（※）"
            />
            <Img
              v-else
              src="/images/ranking/score/score_txt_result_02.svg"
              alt="今回の順位（※）"
            />
          </dt>
          <dd class="flex flex-row justify-center">
            <VNumber :string-array="rankingArray" size="medium" />
            <span
              ><Img
                src="/images/ranking/score/score_txt_number_m_02.svg"
                alt="位"
            /></span>
          </dd>
        </dl>
        <div class="my-4">
          <p v-if="isBestScore">
            <Img
              src="/images/ranking/score/score_txt_05.png"
              alt="なにーっ！新記録だと！？"
              class="image-rendering-pixelated"
              :width="266"
            />
          </p>
          <div class="h-[2px] bg-[#BDBDBD]"></div>
        </div>
        <dl
          v-if="bestScoreArray.length > 0"
          class="flex flex-row items-center justify-center gap-x-2"
        >
          <dt>
            <Img
              src="/images/ranking/score/score_txt_03.svg"
              alt="過去の最高得点"
            />
          </dt>
          <dd class="flex flex-row">
            <VNumber :string-array="bestScoreArray" size="medium" />
            <span
              ><Img
                src="/images/ranking/score/score_txt_number_m_01.svg"
                alt="点"
            /></span>
          </dd>
        </dl>
        <p
          class="mt-4 grid max-w-[279px] grid-cols-[auto_1fr] gap-1 text-xs leading-relaxed before:content-['※']"
        >
          順位・ランキングは毎月1日と14日の0:00にリセットされます。
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import VNumber from './VNumber.vue';
import type { ModeParameter } from '~/api/generated/model';
import { convertIntoArray } from '~/utils/convertIntoArray';

interface Props {
  page: 'result' | 'ranking';
  mode: ModeParameter;
  name: string;
  score: number | undefined;
  ranking: number | undefined;
  bestScore: number | undefined;
  isBestScore?: boolean;
}
const { score, bestScore, ranking, isBestScore } = withDefaults(
  defineProps<Props>(),
  {
    isBestScore: false,
  },
);

const scoreArray = computed(() => {
  return convertIntoArray(score);
});

const bestScoreArray = computed(() => {
  return convertIntoArray(bestScore);
});

const rankingArray = computed(() => {
  return convertIntoArray(ranking);
});
</script>

<style scoped>
.score {
  position: relative;
  margin-bottom: -32px;
}

.score__title {
  position: relative;
  z-index: 1;
}
.score__content {
  position: relative;
  max-width: 100%;
  padding-top: 22px;
  padding-bottom: 12px;
  transform: translateY(-32px);
}
.score__content::before,
.score__content::after {
  position: absolute;
  left: 0;
  width: 100%;
  height: 24px;
  content: '';
  background-size: cover;
}
.score__content::before {
  top: 0;
  background-image: url('/images/ranking/score/score_bg_normal_frame-top.svg');
}
.score__content::after {
  bottom: 0;
  background-image: url('/images/ranking/score/score_bg_normal_frame-bottom.svg');
}

.score__content__inner {
  padding-inline: 24px;
  padding-top: 18px;
  padding-bottom: 12px;
  background-image: url('/images/ranking/score/score_bg_normal_frame-inner.svg');
  background-repeat: repeat-y;
}
</style>
